import { useMemo, useState } from "react";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import { MaterialReactTable } from "material-react-table";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import { instance } from "../Components/config";
import { LoaderBox } from "../Components/LoaderBox";
function UsuariosDelSistema() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const columns = useMemo(() => [
    {
      accessorKey: "userId",
      header: "ID",
      size: 5,
    },
    {
      accessorKey: "name.nombre", //access nested data with dot notation
      header: "Nombre(s)",
      size: 100,
    },
    {
      accessorKey: "name.apellido",
      header: "Apellido(s)",
      size: 100,
    },
    {
      accessorKey: "email",
      header: "Correo electrónico",
      size: 50,
      maxSize: 80
    },
    {
      accessorKey: "roles",
      header: "Roles",
      size: 50,
      maxSize: 80
    },
    {
      accessorKey: "area",
      header: "Área",
      size: 50,
    },
    {
      accessorKey: "puesto",
      header: "Puesto",
      size: 100,
    },
    {
      size: 10,
      accessorFn: (row) => `${row.activo}${row.name}`,
      id: "activo",
      header: "Activo",
      disableColumnMenu: true,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {row.original.activo && <CheckBoxTwoToneIcon color="success" />}
          {!row.original.activo && <CancelTwoToneIcon color="error" />}
        </Box>
      ),
    },
  ]);
  if (isLoading) {
    async function getItems() {
      try {
        const { data } = await instance.get("/users");
        const temp = data.map((user) => ({
          name: {
            nombre: user.nombre,
            apellido: user.apellido,
          },
          area: user.area,
          puesto: user.puesto,
          email: user.correo,
          logueado: false,
          roles: user.roles ? user.roles : "Sin roles asignados",
          activo: user.activo === 1,
          userId: user.id,
        }));
        setItems(temp);
      } catch (error) {
        alert(error);
      }
    }
    getItems();
    setLoading(false);
  }

  return (
    <LoaderBox isLoading={isLoading}>
      <Box
        className="TableContainer"
        sx={{
          marginTop: 2,
        }}
      >
        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={items}
          enableHiding={false}
          enableRowActions
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
              <Tooltip title="Página del usuario">
                <IconButton
                  color="primary"
                  onClick={() =>
                    navigate("/UsuarioInformacion", {
                      state: { id: row.original.userId },
                    })
                  }
                >
                  <ContactPageIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          initialState={{ columnVisibility: { userId: false } }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: "", //change header text
            },
          }}
          defaultColumn={{
            size: 35, //default size is usually 180
          }}
        />
      </Box>
    </LoaderBox>
  );
}

export { UsuariosDelSistema };
